/**
 * Helper function copied from Ceres/resources/js/src/app/helper/get.js
 */
export function get(object, path)
{
    var fieldExp = /{\s*\S+\s*,\s*\S+\s*}|\w+/gm;
    var key;

    while (!!object && (key = fieldExp.exec(path)) !== null)
    {
        if (key.index === fieldExp.lastIndex)
        {
            fieldExp.lastIndex++;
        }

        object = readField(object, key[0]);
    }

    return object;
}

/**
 * Helper function copied from Ceres/resources/js/src/app/helper/get.js
 */
export function readField(object, field)
{
    if (!object)
    {
        return null;
    }

    var match = /^{\s*(\S+)\s*,\s*(\S+)\s*}$/.exec(field);

    if (!!match)
    {
        const searchKey = match[1];
        const searchValue = match[2];

        return Array.prototype.slice.call(object).find(function(entry)
        {
            return (get(entry, searchKey) + "") === searchValue;
        });
    }

    return object[field];
}
